module.exports = __webpack_public_path__ + "static/media/modernhouse.4d1506d9.jpeg";